// ledgerDemoData.js
//
// SINGLE SOURCE OF TRUTH: the finalized dataset lives in ledgerDemoData.json.
// That JSON is also read by the backend Python seed script — both sides use the
// same file, so the demo ledger never drifts between the frontend fixture and the
// seed data.
//
// This module is a thin re-export wrapper. Do NOT add logic here.
// To change the dataset: edit the JSON directly (or re-run gen_demo_json.mjs to
// regenerate it from a revised inline RAW array).

import data from "./ledgerDemoData.json";

export const POSITIONS           = data.positions;
export const BLENDED_IRR         = data.blended_irr;
export const DEMO_REPORT_INVESTOR = data.report_investor;
